import { State, Getter, Action, Mutation, namespace } from 'vuex-class'

export default class VuexHelper {
  private ns: string

  constructor (ns) {
    this.ns = ns
  }

  public get State() {
    return namespace(this.ns, State)
  }

  public get Getter() {
    return namespace(this.ns, Getter)
  }

  public get Action() {
    return namespace(this.ns, Action)
  }

  public get Mutation() {
    return namespace(this.ns, Mutation)
  }
}
